import { Box } from '@rbilabs/universal-components';

import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';

export const LoyaltyLogoContainer = Box.withConfig({
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: Styles.color.background,
  marginTop: {
    base: '$8',
    sm: '$16',
  },
  marginBottom: {
    base: '$6',
    sm: '$8',
  },
});

export const StyledLogo = LoyaltyRewardsLogo.withConfig({
  width: 'full',
  alignItems: 'center',
});
